<template>
    <div class="countries-create-modal">
        <ModalContainer :title="$t('countries.add_country')" identifier="countries-create-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputText v-model="$v.country.code.$model" ref="code" identifier="code" :label="$t('countries.code')"
                               :disabled="is_saving" :has-error="$v.country.code.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.country.code.required">
                            {{$t('validation.x_is_required',{x: $t('countries.code')})}}
                        </p>
                    </template>
                </FormInputText>

                <FormInputText v-model="$v.country.name.$model" identifier="name" :label="$t('countries.name')"
                               :disabled="is_saving" :has-error="$v.country.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.country.name.required">
                            {{$t('validation.x_is_required',{x: $t('countries.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
import ModalContainer from "../modal/ModalContainer";
import Form from "../form/Form";
import FormInputText from "../form/FormInputText";
import FormGroupTwo from "../form/FormGroupTwo";
import FormInputSelect from "../form/FormInputSelect";
import {required, email} from 'vuelidate/lib/validators'
import Button from "../Button";
import FormInputPassword from "@/components/form/FormInputPassword";

export default {
    name: "CountriesCreateModal",
    components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
    data() {
        return {
            country: {
                code: null,
                name: null,
            },
            is_saving: false,
        }
    },
    validations: {
        country: {
            code: {required},
            name: {required},
        }
    },
    methods: {
        close(status) {
            this.$modal.hide('countries-create-modal', status);
        },
        save() {
            this.$v.country.$touch();
            if (this.$v.country.$anyError || this.is_saving)
                return;

            this.is_saving = true;

            const payload = Object.assign({}, this.$v.country.$model);

            this.$axios.post(`countries`, payload).then(({data}) => {
                this.$notify({
                    text: this.$t('countries.success_created'),
                    type: 'success',
                });

                this.is_saving = false;
                this.close(true);
            }).catch(e => {
                this.is_saving = false;

                this.$notify({
                    title: this.$t('error'),
                    text: this.$larerror(e.response.data.errors, this.$t('countries.error_create')),
                    type: 'error',
                });
            });
        }
    },
    mounted() {
        this.$refs.code.$el.children[1].focus();
    }
}
</script>
